module.exports = __webpack_public_path__ + "../static/img/ec.5704ccb2.png";